var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.667969 20.1663V17.833H3.0013V9.66634C3.0013 8.05245 3.48741 6.61842 4.45964 5.36426C5.43186 4.11009 6.69575 3.28856 8.2513 2.89967V2.08301C8.2513 1.5969 8.42144 1.1837 8.76172 0.843424C9.102 0.503147 9.51519 0.333008 10.0013 0.333008C10.4874 0.333008 10.9006 0.503147 11.2409 0.843424C11.5812 1.1837 11.7513 1.5969 11.7513 2.08301V2.89967C13.3069 3.28856 14.5707 4.11009 15.543 5.36426C16.5152 6.61842 17.0013 8.05245 17.0013 9.66634V17.833H19.3346V20.1663H0.667969ZM10.0013 23.6663C9.35964 23.6663 8.81033 23.4379 8.35338 22.9809C7.89644 22.524 7.66797 21.9747 7.66797 21.333H12.3346C12.3346 21.9747 12.1062 22.524 11.6492 22.9809C11.1923 23.4379 10.643 23.6663 10.0013 23.6663ZM5.33464 17.833H14.668V9.66634C14.668 8.38301 14.211 7.2844 13.2971 6.37051C12.3832 5.45662 11.2846 4.99967 10.0013 4.99967C8.71797 4.99967 7.61936 5.45662 6.70547 6.37051C5.79158 7.2844 5.33464 8.38301 5.33464 9.66634V17.833Z",
    fill: "#666666"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bellIcon.dee6830baf51b20ee07bd7c78c4da52a.svg";
export { ForwardRef as ReactComponent };